/**
 * @generated SignedSource<<004317804758c05c3e85978ee00d5889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternTempoConnectionCard_brand$data = {
  readonly id: string;
  readonly tempoApiToken: string | null;
  readonly " $fragmentType": "InternTempoConnectionCard_brand";
};
export type InternTempoConnectionCard_brand$key = {
  readonly " $data"?: InternTempoConnectionCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternTempoConnectionCard_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternTempoConnectionCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoApiToken",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "b76e17374ac5b4dde12015bc6d6bfcaa";

export default node;
